import React from 'react';

import { format } from 'date-fns';
import Moment from 'react-moment';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Table, Tbody, Td, Th, Thead, Tr } from 'react-super-responsive-table';
import { bindActionCreators } from 'redux';

import { getCohorts } from '../../actions/Cohort/CohortAction';
import { setNavigateToMsg } from '../../actions/Notifications/ScreenReaderInit';
import { setPageTitle } from '../../actions/Page/PageAction';
import Constants from '../../Constants';
import CohortSettings from './CohortSettings';
import DeleteCohort from './DeleteCohort';
import { Button } from '../Common';

const { formatDate } = Constants;

class CohortManagent extends React.Component {
  constructor(props) {
    super(props);
    this.timeClear = '';
    this.state = {
      cohortSettings: false,
      cohort: {},
      isNew: false,
      name: '',
      updated: false,
      cohortId: null,
    };
    this.newCohortFormRef = React.createRef();
  }

  componentDidMount() {
    this.props.setPageTitle('Manage Cohorts');
    if (this.props.casDetails.casId !== '') {
      this.props.getCohorts(this.props.casDetails.casId);
    }

    this.props.setNavigateToMsg('Manage Cohorts');
  }

  componentWillUnmount() {
    this.props.setPageTitle();
  }

  componentDidUpdate() {
    this.state.cohortSettings
      ? this.props.setPageTitle(`Cohort Settings ${this.state.cohort.name || ''}`)
      : this.props.setPageTitle('Manage Cohorts');
  }

  handleCancelEditChanges = () => {
    this.setState({
      cohortSettings: false,
    });
    this.props.setNavigateToMsg('Manage Cohorts');
  };

  handleEditChanges = (data) => {
    this.setState({
      cohortSettings: false,
      name: data.name,
      updated: true,
    });
    this.setTimeFunc();
    this.props.setNavigateToMsg('Edit Cohorts');
  };

  addCohort = () => {
    this.clearTimeFunc();
    this.newCohortFormRef.focus();
    this.setState({
      cohortSettings: true,
      cohort: {},
      isNew: true,
    });
    this.props.setNavigateToMsg('Add Cohorts');
  };

  setTimeFunc() {
    this.timeClear = setTimeout(() => {
      this.setState({
        updated: false,
      });
    }, 5000);
  }

  clearTimeFunc() {
    clearTimeout(this.timeClear);
  }

  renderCohorts() {
    var self = this;

    function editCohort(cohort) {
      self.setState({
        cohortSettings: true,
        cohort,
        isNew: false,
      });
      self.clearTimeFunc();
    }

    return this.props.cohorts.map(function (cohort, index) {
      const cohortDate = new Date(cohort.createdDate);
      return (
        <Tr key={index} className="tdata mYSm-10 border-table-gray">
          <Td className="pYSm-20 pLeft-20 max-width-list">{cohort.name}</Td>
          <Td className="pYSm-20 pLeft-15">
            <Moment format={formatDate}>{cohort.createdDate}</Moment>
          </Td>
          <Td className="pYSm-20 pLeft-15">
            <Moment format={formatDate}>{cohort.updatedDate}</Moment>
          </Td>
          <Td className="pYSm-20 pRight-20 pLeft-15 min-width-action">
            <div className="cohortActions">
              <button
                aria-label={`Edit Cohort Name ${cohort.name} Created ${format(cohortDate, 'MMM dd, yyyy h:mm a')}`}
                title={`Edit Cohort Name ${cohort.name} Created ${format(cohortDate, 'MMM dd, yyyy h:mm a')}`}
                onClick={() => editCohort(cohort)}
                className="anchor fontSm-15 pRight-30 ref-blue-text">
                <i className="far fa-pencil lsn-primary-color mRight-5" aria-hidden />
                Edit
              </button>
              <DeleteCohort cohort={cohort} />
            </div>
          </Td>
        </Tr>
      );
    });
  }

  render() {
    const length = (this.props.cohorts || []).length;

    return (
      <React.Fragment>
        {!this.state.cohortSettings && (
          <div tabIndex="-1" className={'init-focus__hidden'}>
            <div className="manageUsers mLeft-15 mRight-45 mobile_margin">
              <div className="verticle-middle pTop-45 lineHeight-30">
                <div className="col-sm-6 text-center fontSm-30 fx-o-2">
                  <h1 className="lsn-heading" id="app_page_title">
                    Manage Cohorts
                  </h1>
                </div>
                <div className="col-sm-3 text-left anchorParent fontSm-15 fx-o-1">
                  <Link to="/reports" className="anchor lsn-primary-color" label="reports">
                    {' '}
                    <i className="fal fa-arrow-left lsn-primary-color mRight-5" />
                    Back to Report
                  </Link>
                </div>
                <div className="col-sm-3 text-right fx-o-3">
                  <Button
                    isNew
                    size="small"
                    appearance="secondary"
                    text="Add Cohort"
                    onClick={this.addCohort}
                    id="button-cohort-add"
                  />
                </div>
              </div>

              <div className="totalUsers mTop-10 mBottom-45 text-center fontSm-15">
                {this.state.updated && (
                  <span className="right-tick fontSm-15 col-">
                    <i className="far fa-check-circle pRight-10" />
                    {this.state.name} Cohort Saved!
                  </span>
                )}
                {this.props.cohorts && !this.state.updated && <span>{this.props.cohorts.length} Total</span>}
              </div>
              {length !== 0 && (
                <div className="listing mobile_margin fontSm-15 cohort-listing">
                  <Table>
                    <Thead>
                      <Tr className="theader">
                        <Th className="pLeft-20 pYSm-20">
                          <span className="ScalaSansOT-Bold bold-font max-width-list">
                            <span>Cohort Name</span>
                          </span>
                        </Th>
                        <Th className="pYSm-20 pLeft-15">
                          <span className="ScalaSansOT-Bold bold-font">
                            <span>Created</span>
                          </span>
                        </Th>
                        <Th className="pYSm-20 pLeft-15">
                          <span className="ScalaSansOT-Bold bold-font">
                            <span>Last Modified</span>
                          </span>
                        </Th>
                        <Th className="pYSm-20 pBottom-10 pLeft-15 min-width-action" aria-hidden="true"></Th>
                      </Tr>
                    </Thead>
                    <Tbody>{this.renderCohorts()}</Tbody>
                  </Table>
                </div>
              )}
            </div>
          </div>
        )}
        <div ref={(ref) => (this.newCohortFormRef = ref)} className={'init-focus__hidden'} tabIndex="-1">
          {this.state.cohortSettings && (
            <CohortSettings
              cohort={this.state.cohort}
              afterEdit={this.handleEditChanges}
              afterCancel={this.handleCancelEditChanges}
              isNew={this.state.isNew}
            />
          )}
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    impersonate: state.Impersonate.impersonate.impersonate,
    cohorts: state.Cohort.cohorts,
    casDetails: state.AppSession.activeCasDetails,
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setNavigateToMsg,
      getCohorts,
      setPageTitle,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(CohortManagent);
